"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nonEditableEditionStatus = void 0;
exports.nonEditableEditionStatus = ["pendingApproval", "approved", "rejected"];
